export const PAGE_HOME = '';
export const PAGE_THREATS = 'threats';
export const PAGE_OFFER = 'offer';
export const PAGE_CONTACT = 'contact';
export const PAGE_PRIVACY = 'privacy-policy';
export const PAGE_LEGAL = 'legal-notice';
export const PAGE_EBOOK = 'ebook';
export const PAGE_WEBINAR = 'webinar';
export const PAGE_ABOUT = 'about';
export const PAGE_ESTIMATION = 'estimation';

export const AVAILABLE_PAGES = [
    PAGE_HOME,
    PAGE_THREATS,
    PAGE_OFFER,
    PAGE_ESTIMATION,
    PAGE_ABOUT,
    PAGE_CONTACT,
    PAGE_PRIVACY,
    PAGE_LEGAL,
    PAGE_EBOOK,
    PAGE_WEBINAR
];



// WEBPACK FOOTER //
// ./src/config/pages.js